/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import rolesConfig from '../config/rolesConfig';
import { getLocalUserData } from '../utils';
import NotFoundContainer from '../app/404/notFoundContainer';
import DashboardContainer from '../app/shared/dashboard/DashboardContainer';
import CreatePasswordContainer from '../app/shared/createPassword/CreatePasswordContainer';
import AdminListContainer from '../app/admin/manager/AdminListContainer';
import AnalyticsContainer from '../app/admin/analytics/AnalyticsContainer';
import CreateOfferContainer from '../app/admin/offer/createOffer/CreateOfferContainer';
import CreateUserContainer from '../app/admin/import/user/CreateUserContainer';
import OfferListingContainer from '../app/admin/offer/listing/OfferListingContainer';
import QuestionnaireContainer from '../app/shared/questionnaire/QuestionnaireContainer';
import OfferDetailContainer from '../app/admin/offer/detail/OfferDetailContainer';

const Routes = {
  DashboardContainer,
  CreatePasswordContainer,
  AdminListContainer,
  CreateOfferContainer,
  CreateUserContainer,
  OfferListingContainer,
  QuestionnaireContainer,
  OfferDetailContainer,
  AnalyticsContainer,
};

export default function PrivateRoutes(props) {
  const { location: { search } } = props;
  let { location: { pathname } } = props;
  if (search.includes('offerId')) {
    const splitOfferId = search.split('=');
    pathname = `${pathname}/${splitOfferId[1]}`;
  }
  const userData = getLocalUserData();
  let roles = [];
  if (userData && userData.role) {
    roles = [
      ...[userData.role],
      'common',
    ];
  }
  const allowedRoutes = roles.reduce((acc, role) => [
    ...acc,
    ...rolesConfig[role].routes,
  ], []);

  return (
    <div>
      <Switch>
        {
        allowedRoutes.length > 0 ? allowedRoutes.map(({ component, url }, index) => (
          <Route
            exact
            key={index}
            path={`${url}`}
            component={Routes[component]}
          />
        )) : (
          <Redirect to={{
            pathname: '/login',
            state: { referrer: pathname },
          }}
          />
        )
      }
        <Route component={NotFoundContainer} />
      </Switch>
    </div>
  );
}

PrivateRoutes.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};
